import castArray from "lodash/fp/castArray";
import filter from "lodash/fp/filter";
import find from "lodash/fp/find";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import has from "lodash/fp/has";
import head from "lodash/fp/head";
import includes from "lodash/fp/includes";
import map from "lodash/fp/map";
import mapValues from "lodash/fp/mapValues";
import reduce from "lodash/fp/reduce";

import { getSelectedFieldValues } from "./selectUserChoices";
import { getFilteredOptions } from "utils";

const mapValuesWithKey = mapValues.convert({ cap: false });

export function getDefaultValues({ customisations, userChoiceValues }) {
  const userChoices = getSelectedFieldValues(userChoiceValues)(customisations);

  return flow(
    flatMap(getOr([], ["fields"])),
    filter(has("defaultValue")),
    reduce((acc, field) => ({ ...acc, [field.name]: field.defaultValue }), {}),
    mapValuesWithKey((valueOrValues, fieldName) => {
      // if defaultValue is an array of possible values,
      // we find the available options for that field (getFilteredOptions)
      // and then filter those options to only include values in the defaultValues array
      // we then choose the first of these (head()), there is usually only one option left from the filter
      return flow(
        castArray,
        filter((value) => {
          if (!has([fieldName, "options"])(userChoices)) {
            return true;
          }
          return flow(
            getOr([], [fieldName, "options"]),
            (options) =>
              getFilteredOptions({
                options,
                userChoiceValues,
              }),
            map(get("value")),
            includes(value)
          )(userChoices);
        }),
        head
      )(valueOrValues);
    })
  )(customisations);
}

const selectDefaultValues = (state) => {
  const { selectedProductId, userChoiceValues } = state.app;

  const customisations = flow(
    getOr([], ["app", "formData", "products"]),
    find((product) => product.id === selectedProductId),
    getOr([], ["customisations"])
  )(state);

  return getDefaultValues({
    customisations,
    userChoiceValues,
  });
};

export default selectDefaultValues;
